// Renders a markdown-derived HTML string with consistent design-token styling.
// Used by /features, /legal, and /blog post bodies.

interface ProseArticleProps {
  html: string
  className?: string
}

export default function ProseArticle({ html, className = '' }: ProseArticleProps) {
  return (
    <div
      className={`prose-article max-w-none text-ink-secondary
        [&>*:first-child]:mt-0
        [&_h1]:text-display-lg [&_h1]:font-medium [&_h1]:text-ink-primary [&_h1]:mt-14 [&_h1]:mb-6 [&_h1]:tracking-[-0.03em]
        [&_h2]:text-display-md [&_h2]:font-medium [&_h2]:text-ink-primary [&_h2]:mt-12 [&_h2]:mb-5 [&_h2]:tracking-[-0.025em]
        [&_h3]:text-display-sm [&_h3]:font-medium [&_h3]:text-ink-primary [&_h3]:mt-10 [&_h3]:mb-4 [&_h3]:tracking-[-0.02em]
        [&_h4]:text-body-xl [&_h4]:font-semibold [&_h4]:text-ink-primary [&_h4]:mt-8 [&_h4]:mb-3
        [&_h5]:text-body-lg [&_h5]:font-semibold [&_h5]:text-ink-primary [&_h5]:mt-6 [&_h5]:mb-2
        [&_p]:text-body-lg [&_p]:my-5 [&_p]:leading-[1.7]
        [&_ul]:my-6 [&_ul]:pl-6 [&_ul]:list-disc [&_ul]:marker:text-brand-700
        [&_ol]:my-6 [&_ol]:pl-6 [&_ol]:list-decimal [&_ol]:marker:text-brand-700
        [&_li]:text-body-lg [&_li]:my-2 [&_li]:leading-[1.7]
        [&_li>p]:my-1
        [&_a]:text-brand-900 [&_a]:underline [&_a]:underline-offset-4 hover:[&_a]:text-brand-700 [&_a]:transition
        [&_strong]:text-ink-primary [&_strong]:font-semibold
        [&_em]:italic
        [&_img]:rounded-2xl [&_img]:my-10 [&_img]:max-w-full [&_img]:shadow-card
        [&_figure]:my-10 [&_figcaption]:text-body-sm [&_figcaption]:text-ink-tertiary [&_figcaption]:mt-3 [&_figcaption]:text-center
        [&_code]:bg-surface-muted [&_code]:rounded-md [&_code]:px-1.5 [&_code]:py-0.5 [&_code]:text-body-sm [&_code]:text-ink-primary [&_code]:font-mono
        [&_pre]:bg-surface-inverse [&_pre]:text-ink-inverse [&_pre]:rounded-2xl [&_pre]:p-6 [&_pre]:my-8 [&_pre]:overflow-x-auto [&_pre]:text-body-sm
        [&_pre_code]:bg-transparent [&_pre_code]:p-0 [&_pre_code]:text-inherit
        [&_blockquote]:my-8 [&_blockquote]:border-l-4 [&_blockquote]:border-brand-200 [&_blockquote]:pl-6 [&_blockquote]:italic [&_blockquote]:text-ink-secondary
        [&_hr]:my-14 [&_hr]:border-0 [&_hr]:border-t [&_hr]:border-line-subtle
        [&_table]:my-8 [&_table]:w-full [&_table]:border-collapse [&_table]:text-body-md
        [&_th]:bg-surface-subtle [&_th]:text-left [&_th]:px-4 [&_th]:py-3 [&_th]:font-semibold [&_th]:text-ink-primary [&_th]:border-b [&_th]:border-line
        [&_td]:px-4 [&_td]:py-3 [&_td]:border-b [&_td]:border-line-subtle [&_td]:text-ink-secondary
        ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}
